import React from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import { SpinnerWrapper } from '../app/App.styled';

function Spinner({ className, dataTestId, size = 40 }) {
  return (
    <SpinnerWrapper className={className} data-testid={dataTestId}>
      <CircularProgress size={size} />
    </SpinnerWrapper>
  );
}

export default Spinner;
